<ngx-particles
  id="win-modal-particles"
  class="particles-container"
  [options]="particlesOptions"
/>

<button class="close-button" (click)="onClose()">
  <svg-icon src="assets/icons/core/close.svg" />
</button>

<div class="winner-section">
  <div class="avatar-wrapper">
    <img
      class="winner-avatar"
      [src]="winnerAvatar()"
      alt="Winner avatar"
    />
    <div class="crown-badge">
      <div class="crown-badge__bg"></div>
      <svg-icon src="assets/icons/games/king.svg" />
    </div>
  </div>

  <h1 class="title">Congratulations!</h1>
  <p class="subtitle">
    You won
    <app-cost [cost]="totalValue()" [balanceType]="'skins'" [gap]="4" />
    with <span class="chance">{{ winnerChance() | number:'1.0-2' }}%</span> chance
  </p>
</div>

<div class="skins-grid-wrapper">
  <app-skins-list
    [skins]="skins()"
    [(selectedSkins)]="selectedSkins"
    [selectable]="selectable()"
    [config]="{
      columns: 4,
      skin_min_width: '120px',
      mobile: {
        skin_min_width: '90px',
        padding: '4px'
      }
    }"
    [balanceType]="'skins'"
  />
</div>

@if (selectable()) {
  <div class="bottom-bar">
    <div class="selection-info">
      <app-cost [cost]="selectedValue()" [balanceType]="'skins'" [gap]="4" />
      <span class="items-count">{{ selectedCount() }}/{{ totalCount() }} items selected</span>
    </div>

    <app-checkbox
      [checked]="selectAll()"
      (checkedChange)="onSelectAllChange($event)"
    >
      Select All
    </app-checkbox>
  </div>
}

<div class="action-buttons">
  @for (btn of visibleButtons(); track btn.action) {
    <button
      class="button h-44 padding-x-24"
      [class.button--style-primary]="btn.style === 'primary'"
      [class.button--style-blue]="btn.style === 'blue'"
      [disabled]="busy() !== null || selectedCount() === 0"
      (click)="act(btn.action, 'manual')"
    >
      {{ labelFor(btn) }}
    </button>
  }
</div>
